var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"mode":"jacket"}},[_c('h1',[_vm._v(_vm._s(_vm.labels.Title))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.labels.Description)}}),_c('div',{staticClass:"vgs-form-indent text-left"},[_c('RouteLink',{attrs:{"route":"signin","icon":"arrow-right","text":_vm.signIn.GoToSignIn}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }